import { Card, CardContent, CardDescription, CardHeader, CardTitle, ErrorState, Spinner } from "@clones/ui";
import { useRespondentChatEnabled, useRuntimeInfo } from "./queries";

/**
 * Gate for the whole respondent own-twin chat SPA.
 *
 * The entire app *is* the gated surface, so — unlike the productive
 * AssessmentFeatureGate, which redirects to a different page — there's
 * nowhere useful to send the user. When the flag is off we render a calm
 * "not available" card. The backend also 404s `/r/chat/*`, `/r/threads/*`
 * and `/r/auth/*`, so this is cosmetic defense-in-depth, not the security
 * boundary.
 */
export function RespondentChatGate({ children }: { children: React.ReactNode }) {
  const { isLoading, isError, isFetching, refetch } = useRuntimeInfo();
  const enabled = useRespondentChatEnabled();

  if (isLoading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (isError) {
    return <ErrorState onRetry={() => void refetch()} retrying={isFetching} />;
  }

  if (!enabled) {
    return (
      <div className="grid min-h-screen place-items-center bg-background p-4">
        <Card className="w-full max-w-md text-center">
          <CardHeader>
            <CardTitle>Раздел недоступен</CardTitle>
            <CardDescription>
              Чат с двойником пока не открыт на этом сервере. Попробуйте позже.
            </CardDescription>
          </CardHeader>
          <CardContent />
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
